import {
  LOAD_STERILIZATION_REPORTS_PENDING,
  LOAD_STERILIZATION_REPORTS_FULFILLED,
  LOAD_STERILIZATION_REPORTS_REJECTED,
  LOAD_STERILIZATION_REPORTS_COUNT_FULFILLED,
  LOAD_STERILIZATION_REPORTS_COUNT_REJECTED,
  LOAD_ANALYTICS_FAULTS_LIST_DATA_PENDING,
  LOAD_ANALYTICS_FAULTS_LIST_DATA_FULFILLED,
  LOAD_ANALYTICS_FAULTS_LIST_DATA_REJECTED,
  LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_PENDING,
  LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_FULFILLED,
  LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_REJECTED,
  LOAD_REGISTERED_DEVICES_CHART_DATA_PENDING,
  LOAD_REGISTERED_DEVICES_CHART_DATA_FULFILLED,
  LOAD_REGISTERED_DEVICES_CHART_DATA_REJECTED,
  LOAD_REGISTERED_DEVICES_TABLE_DATA_PENDING,
  LOAD_REGISTERED_DEVICES_TABLE_DATA_FULFILLED,
  LOAD_REGISTERED_DEVICES_TABLE_DATA_REJECTED,
  LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_PENDING,
  LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_FULFILLED,
  LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_REJECTED,
  LOAD_SOLD_DEVICES_COUNTRIES_PENDING,
  LOAD_SOLD_DEVICES_COUNTRIES_FULFILLED,
  LOAD_SOLD_DEVICES_COUNTRIES_REJECTED,
  LOAD_REGISTERED_DEVICES_COUNTRIES_PENDING,
  LOAD_REGISTERED_DEVICES_COUNTRIES_FULFILLED,
  LOAD_REGISTERED_DEVICES_COUNTRIES_REJECTED,
  LOAD_CONNECTED_DEVICES_COUNTRIES_PENDING,
  LOAD_CONNECTED_DEVICES_COUNTRIES_FULFILLED,
  LOAD_CONNECTED_DEVICES_COUNTRIES_REJECTED,
  REFRESH_REGISTERED_DEVICES_PENDING,
  REFRESH_REGISTERED_DEVICES_FULFILLED,
  REFRESH_REGISTERED_DEVICES_REJECTED,
  DOWNLOAD_REGISTERED_DEVICES_PENDING,
  DOWNLOAD_REGISTERED_DEVICES_FULFILLED,
  DOWNLOAD_REGISTERED_DEVICES_REJECTED,
  LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_PENDING,
  LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_FULFILLED,
  LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_REJECTED,
  DOWNLOAD_GEOGRAPHICAL_CONNECTION_PENDING,
  DOWNLOAD_GEOGRAPHICAL_CONNECTION_FULFILLED,
  DOWNLOAD_GEOGRAPHICAL_CONNECTION_REJECTED,
  LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING,
  LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED,
  LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED,
  LOAD_REGISTERED_USERS_CHART_DATA_PENDING,
  LOAD_REGISTERED_USERS_CHART_DATA_FULFILLED,
  LOAD_REGISTERED_USERS_CHART_DATA_REJECTED,
  LOAD_REGISTERED_USERS_TABLE_DATA_PENDING,
  LOAD_REGISTERED_USERS_TABLE_DATA_FULFILLED,
  LOAD_REGISTERED_USERS_TABLE_DATA_REJECTED,
  LOAD_REGISTERED_USERS_COUNTRIES_PENDING,
  LOAD_REGISTERED_USERS_COUNTRIES_FULFILLED,
  LOAD_REGISTERED_USERS_COUNTRIES_REJECTED,
  DOWNLOAD_REGISTERED_USERS_PENDING,
  DOWNLOAD_REGISTERED_USERS_FULFILLED,
  DOWNLOAD_REGISTERED_USERS_REJECTED,
  LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING,
  LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED,
  LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED,
  DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_PENDING,
  DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_FULFILLED,
  DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_REJECTED,
  DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_PENDING,
  DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_FULFILLED,
  DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_REJECTED,
  REPORTS_CLEAR_MESSAGES,
  LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_FULFILLED,
  LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_FULFILLED,
  DOWNLOAD_FIRMWARE_DOWNLOAD_FULFILLED,
  LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_PENDING,
  DOWNLOAD_FIRMWARE_DOWNLOAD_PENDING,
  LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_PENDING,
  LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_REJECTED,
  DOWNLOAD_FIRMWARE_DOWNLOAD_REJECTED,
  LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_REJECTED,
  LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_PENDING,
  LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_FULFILLED,
  LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_REJECTED,
  LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_PENDING,
  LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_FULFILLED,
  LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_REJECTED,
  DOWNLOAD_REMOTE_ACCESS_CONNECTION_PENDING,
  DOWNLOAD_REMOTE_ACCESS_CONNECTION_FULFILLED,
  DOWNLOAD_REMOTE_ACCESS_CONNECTION_REJECTED,
  LOAD_SOFTWARE_VERSION_RAW_DATA_FULFILLED,
  LOAD_SOFTWARE_VERSION_STATISTICS_DATA_FULFILLED,
  DOWNLOAD_SOFTWARE_VERSION_REPORTS_FULFILLED,
  LOAD_SOFTWARE_VERSION_RAW_DATA_REJECTED,
  LOAD_SOFTWARE_VERSION_STATISTICS_DATA_REJECTED,
  DOWNLOAD_SOFTWARE_VERSION_REPORTS_REJECTED,
  LOAD_SOFTWARE_VERSION_RAW_DATA_PENDING,
  LOAD_SOFTWARE_VERSION_STATISTICS_DATA_PENDING,
  DOWNLOAD_SOFTWARE_VERSION_REPORTS_PENDING,
  LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_FULFILLED,
  LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_PENDING,
  LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_REJECTED,
} from '../actions/reports'

import i18n from 'i18next'

export default function reports(state = {}, action) {
  switch (action.type) {
    case LOAD_STERILIZATION_REPORTS_PENDING:
    case LOAD_SOLD_DEVICES_COUNTRIES_PENDING:
    case LOAD_REGISTERED_DEVICES_COUNTRIES_PENDING:
    case LOAD_CONNECTED_DEVICES_COUNTRIES_PENDING:
    case REFRESH_REGISTERED_DEVICES_PENDING:
    case DOWNLOAD_REGISTERED_DEVICES_PENDING:
    case LOAD_REGISTERED_DEVICES_CHART_DATA_PENDING:
    case LOAD_REGISTERED_DEVICES_TABLE_DATA_PENDING:
    case LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_PENDING:
    case LOAD_ANALYTICS_FAULTS_LIST_DATA_PENDING:
    case LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_PENDING:
    case DOWNLOAD_GEOGRAPHICAL_CONNECTION_PENDING:
    case LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_PENDING:
    case DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_PENDING:
    case DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_PENDING:
    case LOAD_REGISTERED_USERS_COUNTRIES_PENDING:
    case DOWNLOAD_REGISTERED_USERS_PENDING:
    case LOAD_REGISTERED_USERS_CHART_DATA_PENDING:
    case LOAD_REGISTERED_USERS_TABLE_DATA_PENDING:
    case LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_PENDING:
    case DOWNLOAD_FIRMWARE_DOWNLOAD_PENDING:
    case LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_PENDING:
    case LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_PENDING:
    case LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_PENDING:
    case DOWNLOAD_REMOTE_ACCESS_CONNECTION_PENDING:
    case LOAD_SOFTWARE_VERSION_RAW_DATA_PENDING:
    case LOAD_SOFTWARE_VERSION_STATISTICS_DATA_PENDING:
    case DOWNLOAD_SOFTWARE_VERSION_REPORTS_PENDING:
    case LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_PENDING:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        successMessage: null,
      }
    case LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING:
    case LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING:
      return {
        ...state,
        isSoldUnitsLoading: true,
        errorMessage: null,
        successMessage: null,
      }
    case LOAD_STERILIZATION_REPORTS_REJECTED:
    case LOAD_STERILIZATION_REPORTS_COUNT_REJECTED:
    case LOAD_ANALYTICS_FAULTS_LIST_DATA_REJECTED:
    case LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_REJECTED:
    case LOAD_SOLD_DEVICES_COUNTRIES_REJECTED:
    case LOAD_REGISTERED_DEVICES_COUNTRIES_REJECTED:
    case LOAD_CONNECTED_DEVICES_COUNTRIES_REJECTED:
    case REFRESH_REGISTERED_DEVICES_REJECTED:
    case DOWNLOAD_REGISTERED_DEVICES_REJECTED:
    case LOAD_REGISTERED_DEVICES_CHART_DATA_REJECTED:
    case LOAD_REGISTERED_DEVICES_TABLE_DATA_REJECTED:
    case LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_REJECTED:
    case LOAD_REGISTERED_USERS_COUNTRIES_REJECTED:
    case DOWNLOAD_REGISTERED_USERS_REJECTED:
    case LOAD_REGISTERED_USERS_CHART_DATA_REJECTED:
    case LOAD_REGISTERED_USERS_TABLE_DATA_REJECTED:
    case LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_REJECTED:
    case DOWNLOAD_FIRMWARE_DOWNLOAD_REJECTED:
    case LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_REJECTED:
    case DOWNLOAD_GEOGRAPHICAL_CONNECTION_REJECTED:
    case LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_REJECTED:
    case DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_REJECTED:
    case DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_REJECTED:
    case LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_REJECTED:
    case LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_REJECTED:
    case DOWNLOAD_REMOTE_ACCESS_CONNECTION_REJECTED:
    case LOAD_SOFTWARE_VERSION_RAW_DATA_REJECTED:
    case LOAD_SOFTWARE_VERSION_STATISTICS_DATA_REJECTED:
    case DOWNLOAD_SOFTWARE_VERSION_REPORTS_REJECTED:
    case LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }
    case LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED:
    case LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED:
      return {
        ...state,
        isSoldUnitsLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }

    case LOAD_STERILIZATION_REPORTS_FULFILLED:
      return {
        ...state,
        reports: action.payload.data,
        isLoading: false,
      }
    case LOAD_STERILIZATION_REPORTS_COUNT_FULFILLED:
      return {
        ...state,
        totalReports: action.payload.totalResults,
        lastReportsQueryParams: { ...action.meta.queryParams, cacheTime: new Date().getTime() },
      }

    // ------------------------ANALYTICS REPORTS------------------------
    case LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_FULFILLED:
      return {
        ...state,
        analyticsFaultListData: action.payload.data,
        canLoadMoreListData: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_ANALYTICS_FAULTS_LIST_DATA_FULFILLED: {
      const existingList = state?.analyticsFaultListData || []
      const newListIds = action.payload.data?.map((item) => item.id)
      const mergedLists = existingList.filter((list) => !newListIds.includes(list.id)).concat(action.payload.data)

      return {
        ...state,
        analyticsFaultListData: mergedLists,
        canLoadMoreListData: action.payload.nextPage,
        isLoading: false,
      }
    }

    // ------------------------REGISTERED DEVICES------------------------
    case LOAD_REGISTERED_DEVICES_CHART_DATA_FULFILLED:
      return {
        ...state,
        registeredDevicesChartData: action.payload,
        isLoading: false,
      }
    case LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_FULFILLED:
      return {
        ...state,
        registeredDevicesTableData: action.payload.data,
        canLoadMoreTableData: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_REGISTERED_DEVICES_TABLE_DATA_FULFILLED: {
      const existingDevices = state?.registeredDevicesTableData || []
      const newDeviceIds = action.payload.data?.map((item) => item.id)
      const mergedDevices = existingDevices.filter((device) => !newDeviceIds.includes(device.id)).concat(action.payload.data)

      return {
        ...state,
        registeredDevicesTableData: mergedDevices,
        canLoadMoreTableData: action.payload.nextPage,
        isLoading: false,
      }
    }
    case LOAD_SOLD_DEVICES_COUNTRIES_FULFILLED:
      return {
        ...state,
        soldDevicesCountries: action.payload,
        isLoading: false,
      }
    case LOAD_REGISTERED_DEVICES_COUNTRIES_FULFILLED:
      return {
        ...state,
        registeredDevicesCountries: action.payload,
        isLoading: false,
      }
    case LOAD_CONNECTED_DEVICES_COUNTRIES_FULFILLED:
      return {
        ...state,
        connectedDevicesCountries: action.payload,
        isLoading: false,
      }
    case REFRESH_REGISTERED_DEVICES_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.refresh_success'),
      }
    case DOWNLOAD_REGISTERED_DEVICES_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.download_success_registered_devices'),
      }

    // ------------------------GEOGRAPHICAL CONNECTION REPORTS------------------------
    case LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_FULFILLED:
      return {
        ...state,
        geographicalConnectionSummaryData: action.payload,
        isLoading: false,
      }
    case DOWNLOAD_GEOGRAPHICAL_CONNECTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.download_success_geographical_connection'),
      }

    // ------------------------SOLD UNITS CONNECTION REPORTS------------------------
    case LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED:
      return {
        ...state,
        soldUnitsConnectionTableData: action.payload,
        canLoadMoreTableData: action.payload.nextPage,
        isSoldUnitsLoading: false,
      }
    case LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED: {
      const existingSoldData = state?.soldUnitsConnectionTableData || []
      const newSoldIds = action.payload.data?.map((item) => item.id)
      const mergedSoldData = existingSoldData.filter((device) => !newSoldIds.includes(device.id)).concat(action.payload.data)

      return {
        ...state,
        soldUnitsConnectionTableData: mergedSoldData,
        canLoadMoreTableData: action.payload.nextPage,
        isSoldUnitsLoading: false,
      }
    }
    case DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.download_raw_success_sold_units_connection'),
      }
    case DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.download_statistic_success_sold_units_connection'),
      }

    // ------------------------REGISTERED USERS------------------------
    case LOAD_REGISTERED_USERS_CHART_DATA_FULFILLED:
      return {
        ...state,
        registeredUsersChartData: action.payload,
        isChartLoading: false,
      }
    case LOAD_REGISTERED_USERS_TABLE_DATA_FULFILLED:
      return {
        ...state,
        registeredUsersTableData: action.payload,
        canLoadMoreTableData: false,
        isTableLoading: false,
      }
    case LOAD_REGISTERED_USERS_COUNTRIES_FULFILLED:
      return {
        ...state,
        registeredUsersCountries: action.payload,
        isLoading: false,
      }
    case DOWNLOAD_REGISTERED_USERS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.download_success_registered_users'),
      }

    // ------------------------FIRMWARE DOWNLOAD REPORTS------------------------
    case LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_FULFILLED:
      return {
        ...state,
        firmwareDownloadStatisticsData: action.payload,
        isLoading: false,
      }
    case LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_FULFILLED:
      return {
        ...state,
        firmwareDownloadCountries: action.payload,
        isLoading: false,
      }
    case DOWNLOAD_FIRMWARE_DOWNLOAD_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.download_success_firmware_download'),
      }

    case REPORTS_CLEAR_MESSAGES:
      return {
        ...state,
        errorMessage: null,
        successMessage: null,
      }

    // ------------------------ REMOTE ACCESS CONNECTION REPORTS------------------------
    case LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_FULFILLED:
      return {
        ...state,
        remoteAccessConnectionRawData: action.payload.data,
        canLoadMoreRawData: action.payload.nextPage,
        isRawDataLoading: false,
      }
    case LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_FULFILLED:
      return {
        ...state,
        remoteAccessConnectionStatisticsData: action.payload,
        isStatisticsDataLoading: false,
      }
    case DOWNLOAD_REMOTE_ACCESS_CONNECTION_FULFILLED:
      return {
        ...state,
        isDownloadLoading: false,
        successMessage: i18n.t('reports.download_success_remote_access_connection_report'),
      }

    // ------------------------ SOFTWARE VERSION REPORTS------------------------
    case LOAD_SOFTWARE_VERSION_RAW_DATA_FULFILLED:
      return {
        ...state,
        softwareVersionRawData: action.payload.data,
        canLoadMoreTableData: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_SOFTWARE_VERSION_STATISTICS_DATA_FULFILLED:
      return {
        ...state,
        softwareVersionStatisticsData: action.payload,
        canLoadMoreTableData: action.payload.nextPage,
        isLoading: false,
      }
    case DOWNLOAD_SOFTWARE_VERSION_REPORTS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('reports.download_success_software_version'),
      }
    case LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        softwareVersionFilterOptions: action.payload,
      }
    default:
      return state
  }
}

